/**
 * Color intention that you want to used in your theme
 * @param {JsonObject} theme Theme customization object
 */
import { PaletteOptions } from '@mui/material';
import { PaletteSecondary, PalettePrimary } from './global.theme';

export const themePalette = (): PaletteOptions => {
	return {
		primary: {
			main: PalettePrimary,
			contrastText: '#ffffff'
		},
		secondary: {
			main: PaletteSecondary,
			contrastText: '#ffffff'
		},
		background: {
			// default: PalettePrimaryLight
		},
	};
};
